@let companyDetails = getCompanyByIdState.response()?.data;
<div class="w-full min-h-screen flex flex-col bg-gray-100 p-6 gap-8">
  <div class="flex flex-col gap-6">

    <div class="stats flex flex-col gap-4 bg-white rounded-md p-6">
      <div class="flex items-center gap-4">
        <div>
          <p class=" py-2 text-h6 font-semibold text-gray-800">
            {{ companyDetails?.companyName ?? 'N/A' }}
          </p>
          <p class="text-caption text-gray-500 flex items-center gap-2">
            {{ companyDetails?.code }} |
            Status:
            <span
              class="px-3 py-1 rounded-full text-caption font-medium"
              [ngClass]="{
      'bg-success-100 text-success-500': !isEnableCompany(),
      'bg-error-100 text-error-500': isEnableCompany()
    }"
            >
    {{ isEnableCompany() ? 'Inactive' : 'Active' }}
  </span>
          </p>
        </div>

        <div class="ml-auto">
          @if (isEnableCompany()) {
            <app-button appearance="outline" buttonColor="text-error-500" (click)="onEnableCompanyClicked()"
                        [loading]="enableCompanyState.loading()">Enable
            </app-button>
          } @else {
            <app-button appearance="outline" outlineColor="border-error-500" textButtonColor="text-error-500"
                        (click)="onDisableCompanyClicked()" [loading]="disableCompanyState.loading()">Disable
            </app-button>
          }
        </div>

      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <div class="bg-rose-50 rounded-md p-4">
          <p class="text-subtitle2 text-gray-500">Total Drivers</p>
          <p class="text-h4 font-bold text-gray-800">{{ companyDetails?.report?.totalDrivers ?? '0' }}</p>
        </div>
        <div class="bg-blue-50 rounded-md p-4">
          <p class="text-subtitle2 text-gray-500">Total Applications</p>
          <p class="text-h4 font-bold text-gray-800">{{ companyDetails?.report?.totalDriverApplications ?? '0' }}</p>
        </div>
        <div class="bg-amber-50 rounded-md p-4">
          <p class="text-subtitle2 text-gray-500">Pending Applications</p>
          <p class="text-h4 font-bold text-gray-800">{{ companyDetails?.report?.pendingDriverApplications ?? '0' }}</p>
        </div>
        <div class="bg-slate-50 rounded-md p-4">
          <p class="text-subtitle2 text-gray-500">Total Terminals</p>
          <p class="text-h4 font-bold text-gray-800">{{ companyDetails?.report?.totalTerminals ?? '0' }}</p>
        </div>
      </div>
    </div>

    <form [formGroup]="generalInformationForm">
      <div class="bg-white rounded-md p-6">
        <div class="flex justify-between items-center">
          <p class="text-h6 font-semibold text-info-500">General Information</p>
          @if (isEditBasicDetails()) {
            <div class="flex gap-x-2">
              <app-button [appearance]="'outline'" (click)="onCancelGeneralInformationClicked()">Cancel</app-button>
              <app-button (click)="onUpdateGeneralInfoClicked()" [loading]="updateGeneralInfoState.loading()"
              >Save
              </app-button>
            </div>

          } @else {
            <app-button (click)="onEditBasicDetailsClicked()">
              Edit
            </app-button>
          }
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <app-text-input formControlName="companyName" [label]="'Company Name'" [fullWidth]="true">
            </app-text-input>
          </div>
          <div>
            <app-text-input formControlName="dba" [label]="'Doing Business As'" [fullWidth]="true">
            </app-text-input>
          </div>
          <div>
            <app-text-input formControlName="companyPrefix" [label]="'Company Prefix'" [fullWidth]="true">
            </app-text-input>
          </div>
          <div>
            <app-dropdown
              formControlName="accountType"
              [title]="'Account Type'"
              [display]="'displayName'"
              placeholder="Ex: Company"
              [value]="'name'"
              [noDataMessage]="'No Options Available'"
              [fullWidth]="true"
              (valueChanged)="onAccountTypeChanged($event)"
              [items]="accountTypeState.response()?.data ?? []">
            </app-dropdown>
          </div>

          <div>
            <app-text-input formControlName="einNumber" [label]="'EIN Number'" [fullWidth]="true">
            </app-text-input>
          </div>

          <div>
            <app-text-input formControlName="email" [label]="'Email'"
                            class="w-full" [fullWidth]="true"></app-text-input>
          </div>
          <div>
            <app-text-input formControlName="phoneNumber" [label]="'Phone Number'"
                            class="w-full" [fullWidth]="true"></app-text-input>
          </div>
        </div>
      </div>
    </form>

    <form [formGroup]="businessAddressForm">
      <div class="bg-white rounded-md p-6">
        <div class="flex justify-between items-center">
          <p class="text-h6 font-semibold text-info-500">Business Address</p>
          @if (isAddressEditable()) {
            <div class="flex gap-x-2">
              <app-button [appearance]="'outline'" (click)="onCancelBusinessAddressClicked()">Cancel</app-button>
              <app-button (click)="onUpdateBusinessAddressClicked()" [loading]="updateBusinessAddressState.loading()"
              >Save
              </app-button>
            </div>
          } @else {
            <app-button (click)="onEditAddressDetailsClicked()">Edit</app-button>
          }
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <app-dropdown
              formControlName="companyType"
              [title]="'Company Type'"
              [display]="'name'"
              [value]="'id'"
              [enableSearch]="true"
              [noDataMessage]="'No Options Available'"
              [items]="companyTypesState.response()?.data ?? []"
              [fullWidth]="true">
            </app-dropdown>
          </div>
          <div>
            <app-text-input formControlName="addressLine1" [label]="'Address Line 1'"
                            class="w-full" [fullWidth]="true"></app-text-input>
          </div>
          <div>
            <app-text-input formControlName="addressLine2" [label]="'Address Line 2'"
                            class="w-full" [fullWidth]="true"></app-text-input>
          </div>
          <div>
            <app-dropdown
              formControlName="country"
              [title]="'Country'"
              [display]="'name'"
              placeholder="Ex: United States"
              [value]="'id'"
              [noDataMessage]="'No Options Available'"
              [enableSearch]="true"
              class="w-full"
              [fullWidth]="true"
              [items]="countryListState.response()?.data ?? []"
              (valueChanged)="onCountrySelected($event)"
            ></app-dropdown>
          </div>

          <div>
            <app-dropdown
              formControlName="stateId"
              [items]="statesList"
              [title]="'State'"
              [display]="'name'"
              [value]="'id'"
              [enableSearch]="true"
              [noDataMessage]="'No Options Available'"
              class="w-full"
              [fullWidth]="true"
            ></app-dropdown>
          </div>

          <div>
            <app-text-input formControlName="city" [label]="'City'"
                            class="w-full" [fullWidth]="true"></app-text-input>
          </div>
          <div>
            <app-text-input formControlName="zipCode" [label]="'Zipcode'"
                            class="w-full" [fullWidth]="true"></app-text-input>
          </div>


        </div>
      </div>
    </form>
    <form [formGroup]="businessInformationForm">
      <div class="bg-white rounded-md p-6">
        <div class="flex justify-between items-center">
          <p class="text-h6 font-semibold text-info-500">Business Information</p>
          @if (isBusinessInformationEditable()) {
            <div class="flex gap-x-2">
              <app-button [appearance]="'outline'" (click)="onCancelBusinessInformationClicked()">Cancel</app-button>
              <app-button (click)="onUpdateBusinessInformationClicked()"
                          [loading]="updateBusinessInformationState.loading()">Save
              </app-button>
            </div>
          } @else {
            <app-button (click)="onEditBusinessInformationClicked()">Edit</app-button>
          }
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <app-dropdown
              formControlName="businessTypeId"
              [title]="'Business Type'"
              [display]="'name'"
              placeholder="Ex: Truck"
              [value]="'id'"
              [noDataMessage]="'No Options Available'"
              [fullWidth]="true"
              [enableSearch]="true"
              [items]="businessTypeState.response()?.data ?? []"
              (valueChanged)="onBusinessTypeChanged($event)">
            </app-dropdown>
          </div>

          <div>
            @if (this.businessInformationForm.controls['businessTypeId'].value === 'BUS') {
              <app-dropdown
                formControlName="businessSubTypeId"
                [title]="'Business Sub Type'"
                [display]="'name'"
                [value]="'id'"
                [noDataMessage]="'No Options Available'"
                [fullWidth]="true"
                [enableSearch]="true"
                [items]="businessSubTypeState.response()?.data ?? []">
              </app-dropdown>
            }
          </div>

          <div>
            <app-text-input
              formControlName="dotNumber"
              [label]="'Dot Number'"
              class="w-full"
              [fullWidth]="true">
            </app-text-input>
          </div>

          <div class="md:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <app-text-input
                formControlName="businessRepresentativeFirstName"
                [label]="'Business Representative First Name'"
                placeholder="Ex: John"
                class="w-full"
                [fullWidth]="true">
              </app-text-input>
            </div>

            <div>
              <app-text-input
                formControlName="businessRepresentativeLastName"
                [label]="'Business Representative Last Name'"
                placeholder="Ex: Bravo"
                class="w-full"
                [fullWidth]="true">
              </app-text-input>
            </div>
          </div>

          <div class="md:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <app-text-input
                formControlName="businessRepresentativeEmail"
                [label]="'Business Representative Contact Email'"
                class="w-full"
                [fullWidth]="true">
              </app-text-input>
            </div>

            <div>
              <app-text-input
                formControlName="businessRepPhoneNumber"
                [label]="'Business Representative Phone Number'"
                class="w-full"
                [fullWidth]="true">
              </app-text-input>
            </div>
          </div>

          @if (selectedAccountType === 'Individual') {
            <div>
              <app-text-input
                formControlName="ownerSsnNumber"
                [label]="'SSN Number'"
                placeholder="Ex: XXX-XX-XXXX"
                class="w-full"
                [fullWidth]="true">
              </app-text-input>
            </div>
          }

          @if (selectedAccountType === 'Company') {
            <div>
              <app-text-input
                formControlName="einNumber"
                [label]="'EIN Number'"
                placeholder="Ex: XX-XXXXXXX"
                class="w-full"
                [fullWidth]="true">
              </app-text-input>
            </div>
          }

          <div>
            <app-multi-selection-field
              formControlName="carrierType"
              [title]="'Carrier Type'"
              [display]="'name'"
              [value]="'id'"
              [identifier]="'id'"
              [items]="carrierTypeState.response()?.data ?? []"
              (valueChanged)="onSelectedCarrierChanged($event)"
              [showSelectionTickMark]="true">
            </app-multi-selection-field>
          </div>

          @if (isInterStateSelected()) {
            <div>
              <app-text-input
                formControlName="mcNumber"
                [label]="'MC #'"
                placeholder="Ex: MC# 12345"
                class="w-full"
                [fullWidth]="true">
              </app-text-input>
            </div>
          }

          @if (isIntraStateSelected()) {
            <div>
              <app-text-input
                formControlName="caNumber"
                [label]="'CA/MCP #'"
                placeholder="Ex: MCP# 12345"
                class="w-full"
                [fullWidth]="true">
              </app-text-input>
            </div>
          }

          <div class="col-span-2 gap-3">
        <span class="text-body2">
          Does your company transport hazardous materials (HAZMAT) in compliance with safety and regulatory standards?
        </span>
            <div class="py-2 flex items-center gap-3">
              <app-radio-button
                formControlName="transportsHazmat"
                [groupName]="'transportsHazmat'"
                title="Yes"
                [value]="true">
              </app-radio-button>
              <app-radio-button
                formControlName="transportsHazmat"
                [groupName]="'transportsHazmat'"
                title="No"
                [value]="false">
              </app-radio-button>
            </div>
          </div>

          <div class="col-span-2 gap-3">
        <span class="text-body2">
          Does your company transport hazardous waste (HAZWASTE) in compliance with safety and regulatory standards?
        </span>
            <div class="py-2 flex items-center gap-3">
              <app-radio-button
                formControlName="transportsHazwaste"
                [groupName]="'transportsHazwaste'"
                title="Yes"
                [value]="true">
              </app-radio-button>
              <app-radio-button
                formControlName="transportsHazwaste"
                [groupName]="'transportsHazwaste'"
                title="No"
                [value]="false">
              </app-radio-button>
            </div>
          </div>
        </div>
      </div>
    </form>


  </div>

  @if (
    (companyDetails?.report?.documentExpiryDetails?.length ?? 0) > 0 ||
    (companyDetails?.report?.nextDueDateDocuments?.length ?? 0) > 0
    )
  {
    <div class="bg-white p-6 rounded-md grid grid-cols-1 md:grid-cols-2 gap-4">

      <div class="flex flex-col gap-4 h-full">
        @for (doc of companyDetails?.report?.documentExpiryDetails; track $index; let last = $last) {
          <div class="flex flex-col gap-4 p-4 border rounded-md">

            <p class="text-h6 font-semibold text-info-500">Document Expiry Summary</p>
            <div class="flex flex-col gap-3">
              <p class="text-subtitle1 text-gray-700">{{ doc.name }}</p>
              <div class="flex items-center gap-2">
                <p class="text-body2 text-gray-500">Expiring: </p>
                <p class="text-body2 font-semibold text-yellow-600">{{ doc.expiringCount }}</p>
              </div>

              <div class="flex items-center gap-2">
                <p class="text-body2 text-gray-500">Expired: </p>
                <p class="text-body2 font-semibold text-red-600">{{ doc.expiredCount }}</p>
              </div>

            </div>
          </div>
        }
      </div>

      <div class="flex flex-col gap-4 h-full">
        @for (doc of companyDetails?.report?.nextDueDateDocuments; track doc.name) {
          <div class="p-4 border rounded-md">
            <p class="text-h6 font-semibold text-info-500">Next Due Date Documents</p>

            <div class="flex flex-col">
              <p class="text-subtitle1 text-gray-700">{{ doc.name }}</p>
              <p class="text-caption text-gray-500">Count: <span
                class="font-semibold text-blue-600">{{ doc.count }}</span></p>
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>


